import { render } from "./course.vue?vue&type=template&id=463c4868&scoped=true"
import script from "./course.vue?vue&type=script&lang=js"
export * from "./course.vue?vue&type=script&lang=js"

import "./course.vue?vue&type=style&index=0&id=463c4868&lang=scss&scoped=true"
const cssModules = {}
import style1 from "./course.vue?vue&type=style&index=1&id=463c4868&lang=scss&module=true"
cssModules["$style"] = style1

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-463c4868"]])

export default __exports__